var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0004 5.96797C14.9504 5.95964 14.8921 5.95964 14.8421 5.96797C13.6921 5.92631 12.7754 4.98464 12.7754 3.81797C12.7754 2.6263 13.7337 1.66797 14.9254 1.66797C16.1171 1.66797 17.0754 2.63464 17.0754 3.81797C17.0671 4.98464 16.1504 5.92631 15.0004 5.96797Z",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1422 12.0348C15.2839 12.2264 16.5422 12.0264 17.4255 11.4348C18.6005 10.6514 18.6005 9.3681 17.4255 8.58477C16.5339 7.9931 15.2589 7.7931 14.1172 7.9931",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.97539 5.96797C5.02539 5.95964 5.08372 5.95964 5.13372 5.96797C6.28372 5.92631 7.20039 4.98464 7.20039 3.81797C7.20039 2.6263 6.24206 1.66797 5.05039 1.66797C3.85873 1.66797 2.90039 2.63464 2.90039 3.81797C2.90872 4.98464 3.82539 5.92631 4.97539 5.96797Z",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.83353 12.0348C4.69186 12.2264 3.43353 12.0264 2.5502 11.4348C1.3752 10.6514 1.3752 9.3681 2.5502 8.58477C3.44186 7.9931 4.71686 7.7931 5.85853 7.9931",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.99941 12.1906C9.94941 12.1823 9.89108 12.1823 9.84108 12.1906C8.69108 12.149 7.77441 11.2073 7.77441 10.0406C7.77441 8.84896 8.73275 7.89062 9.92441 7.89062C11.1161 7.89062 12.0744 8.85729 12.0744 10.0406C12.0661 11.2073 11.1494 12.1573 9.99941 12.1906Z",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.57461 14.8148C6.39961 15.5982 6.39961 16.8815 7.57461 17.6648C8.90794 18.5565 11.0913 18.5565 12.4246 17.6648C13.5996 16.8815 13.5996 15.5982 12.4246 14.8148C11.0996 13.9315 8.90794 13.9315 7.57461 14.8148Z",
    stroke: "#F3000B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.b1a03f94fa4900c0d49df76ebd5126a5.svg";
export { ForwardRef as ReactComponent };